//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { NameDisplayItem } from './NameDisplayItem';

export class TeacherNameDisplayItem extends NameDisplayItem {
    Active: boolean = false;
    IsTeacher: boolean = false;
    Subjects: string[] = [];     // OBSOLETE - Use only for compatibility
    BiographyBody: string | null = null;
    HasProfilePicture: boolean = false;
    ProfileHeadshotURL: string | null = null;

    constructor(initializer?: Partial<TeacherNameDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "TeacherNameDisplayItem";
}
